import { render, staticRenderFns } from "./personInfoPop.vue?vue&type=template&id=bea6d702&scoped=true"
import script from "./personInfoPop.vue?vue&type=script&lang=js"
export * from "./personInfoPop.vue?vue&type=script&lang=js"
import style0 from "./personInfoPop.vue?vue&type=style&index=0&id=bea6d702&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea6d702",
  null
  
)

export default component.exports